import { translate } from "~/plugins/I18n.ts";

/**
 * Traverse an object using a path string and return the value at the path.
 */
export function get(obj: any, path: string, defaultValue?: string) {
  const travel = (regexp: RegExp) =>
    String.prototype.split
      .call(path, regexp)
      .filter(Boolean)
      .reduce(
        (res, key) => (res !== null && res !== undefined ? res[key] : res),
        obj
      );
  const result = travel(/[,[\]]+?/) || travel(/[,[\].]+?/);

  if (result === null) {
    console.warn("Could not find key '" + path + "' in object", obj);
    return "Geen " + translate(`common.attributes.${path}`);
  }

  return typeof result === 'undefined' || result === obj ? defaultValue : result;
}
